import * as React from 'react';
import { injectIntl } from 'react-intl';

import TextInput from '../../../components/text-input';

import messages from '../messages';

import './TextField.scss';

var TextField = function TextField(_ref) {
    var dataKey = _ref.dataKey,
        dataValue = _ref.dataValue,
        displayName = _ref.displayName,
        description = _ref.description,
        error = _ref.error,
        intl = _ref.intl,
        onChange = _ref.onChange,
        onRemove = _ref.onRemove,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type;

    var value = '';

    if (typeof dataValue === 'number') {
        value = dataValue;
    } else if (dataValue) {
        value = dataValue;
    }

    return React.createElement(TextInput, {
        className: 'metadata-instance-editor-field-text',
        description: description,
        error: error,
        hideOptionalLabel: true,
        label: displayName,
        onChange: function (_onChange) {
            function onChange(_x) {
                return _onChange.apply(this, arguments);
            }

            onChange.toString = function () {
                return _onChange.toString();
            };

            return onChange;
        }(function (event) {
            var currentTarget = event.currentTarget;
            var value = currentTarget.value;
            if (value) {
                onChange(dataKey, currentTarget.value);
            } else {
                onRemove(dataKey);
            }
        }),
        placeholder: intl.formatMessage(messages.metadataFieldSetValue),
        type: type,
        value: value
    });
};

TextField.propTypes = {
    dataKey: PropTypes.string.isRequired,
    dataValue: function dataValue() {
        return (typeof bpfrpt_proptype_FieldValue === 'function' ? bpfrpt_proptype_FieldValue : PropTypes.shape(bpfrpt_proptype_FieldValue)).apply(this, arguments);
    },
    description: PropTypes.string,
    displayName: PropTypes.string.isRequired,
    error: PropTypes.node,
    intl: function intl(props, propName, componentName) {
        if (!Object.prototype.hasOwnProperty.call(props, propName)) {
            throw new Error('Prop `' + propName + '` has type \'any\' or \'mixed\', but was not provided to `' + componentName + '`. Pass undefined or any other value.');
        }
    },
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    type: PropTypes.string
};
export { TextField as TextFieldBase };
export default injectIntl(TextField);
import { bpfrpt_proptype_FieldValue } from '../flowTypes';
import PropTypes from 'prop-types';